import { Component, Input } from '@angular/core';

@Component({
  selector: 'contract-modification-request-sent',
  templateUrl: './request-sent.component.html',
  styleUrls: ['./request-sent.component.scss'],
  standalone: false,
})
export class RequestSentComponent {
  @Input() public navigateToListHandler: any;
}
